import { createContext, useReducer } from "react";
import * as types from "./types";

const initialState = {
  userList: {},
  userData: {},
  query: {},
};

const userReducer = (state, action) => {
  switch (action.type) {
    case types.GET_USER_LISTING:
      return {
        ...state,
        userList: action.payload,
      };
    case types.GET_USER_BY_ID:
      return {
        ...state,
        userData: action.payload,
      };
    case types.SET_QUERY:
      return {
        ...state,
        query: action.payload,
      };
    default:
      return state;
  }
};

export const UserContext = createContext(initialState);

const UserProvider = ({ children }) => {
  const [userState, userDispatch] = useReducer(userReducer, initialState);

  return (
    <UserContext.Provider value={[userState, userDispatch]}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
